module.exports = __webpack_public_path__ + "static_pc/img/fond02.28a1f588.png";